import type { TFunction } from 'i18next'

import { Text } from '@enechain/ecloud-designsystem'

import type { MasterDataTableColumn } from '~/components/common/MasterDataTable'
import { convertAreaLabel } from '~/models/area'
import { VoltageBadges } from '~/pages/CustomerInfo/components/VoltageBadges'
import type { CustomerSummary } from '~/pages/CustomerInfo/models/types'

/** 需要家一覧の列: 需要家名 / 契約者 / エリア / 電圧階級。 */
export const buildCustomerColumns = (
  t: TFunction,
): Array<MasterDataTableColumn<CustomerSummary>> => {
  const none = t('page:customerInfo.common.none')
  return [
    {
      key: 'customerName',
      header: t('page:customerInfo.list.column.customerName'),
      cell: (row) => row.customerName,
    },
    {
      key: 'contractorName',
      header: t('page:customerInfo.list.column.contractorName'),
      cell: (row) => row.contractorName,
    },
    {
      key: 'area',
      header: t('page:customerInfo.list.column.area'),
      cell: (row) =>
        row.areaCodes.length === 0 ? none : convertAreaLabel(row.areaCodes[0]),
    },
    {
      key: 'voltage',
      header: t('page:customerInfo.list.column.voltage'),
      cell: (row) =>
        row.voltageClasses.length === 0 ? (
          <Text as="span" color="Text.lowEmphasis">
            {none}
          </Text>
        ) : (
          <VoltageBadges voltages={row.voltageClasses} />
        ),
    },
  ]
}
